import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { LoadingButtonModule } from "src/app/common/loading-button/loading-button.module";
import { SharedModules } from "src/app/shared.modules";
import { AccountService } from "src/swagger/api.client.generated";
import { LoginComponent } from "../login/login.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ErrorDisplayComponent } from "src/app/common/error-display/error-display.component";
import { PillButtonComponent } from "src/app/common/pill-button/pill-button.component";
import { AuthLayoutComponent } from "src/app/common/auth-layout/auth-layout.component";
@NgModule({
  declarations: [LoginComponent],
  imports: [
    RouterModule,
    SharedModules,
    LoadingButtonModule,
    AngularSvgIconModule,
    ErrorDisplayComponent,
    PillButtonComponent,
    AuthLayoutComponent,
  ],
  providers: [AccountService],
})
export class LoginModule {}
